// const url = "https://paranasdynaslope.com";
const url = "https://dynaslope.com.ph:5001";
export const host = `${url}:5000`;
export const base_url = url;
export const storage_host = `${url}:8000`;
export const CBEWSL_SITE = 18;
export const CBEWSL_SITE_CODE = "ina";
export const CBEWSL_SITE_NAME = "inabasan";
export const CBEWSL_SITE_LOCATION = "Brgy. Inabasan, Maasin, Iloilo";
export const WSS_KEY =
  "833c2bfed00681143663109354ee65f951f963797f0507a93bb13ea26b69557920cbde40ca6466540cddfb39cb0a4e03e0717dc26b7c0e655cba80bffedaa407";
